// useGeoData.js
import { useState, useEffect } from "react";
import useAxiosInstance from "../../../../lib/useAxiosInstance";

const useGeoData = (id) => {
  const axiosInstance = useAxiosInstance();
  const [polyData, setPolyData] = useState([]);

  const fetchParliamentById = async (id) => {
    if (id) {
      return axiosInstance.get(`api/parliment/getParlimentById/${id}`);
    } else {
      return Promise.resolve({ data: null });
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const initialData = await fetchParliamentById(id);
        setPolyData([initialData?.data?.data]);
      } catch (error) {
        console.error("Error fetching initial data:", error);
      }
    };

    if (id) {
      fetchData();
    }
  }, [id]);

  return [polyData, setPolyData];
};

export default useGeoData;
